<div class="relative w-full text-gray-900 dark:text-gray-100" (keydown)="onKeyDown($event)">
  <!-- Trigger Button -->
  <button
    (click)="toggle()"
    type="button"
    class="w-full text-sm flex justify-between items-center bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2.75 hover:bg-gray-50 dark:hover:bg-gray-600 transition-all outline-none"
  >
    <span
      [class.text-gray-400]="!getSelectedLabel()"
      class="whitespace-nowrap overflow-hidden overflow-ellipsis"
      >{{ getSelectedLabel() || 'Select...' }}</span
    >
    <app-icon
      name="angle-down"
      class="w-5 h-5 text-gray-400 transition-transform"
      fill="none"
      [class.rotate-180]="isOpen"
    ></app-icon>
  </button>

  <!-- Dropdown Card -->
  @if (isOpen) {
    <div
      class="absolute z-20 mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-xl overflow-hidden animate-in fade-in zoom-in duration-150"
    >
      <!-- Search Input Area -->
      <div class="p-2 border-b border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800">
        <div class="relative">
          <app-icon name="search" class="absolute left-3 top-3 h-4 w-4 text-gray-400" fill="none" />
          <input
            [formControl]="searchControl"
            type="text"
            placeholder="Search..."
            class="w-full pl-9 pr-4 py-2 text-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-md focus:outline-none"
            (click)="$event.stopPropagation()"
          />
        </div>
      </div>
      <!-- Scrollable List -->
      <ul class="max-h-[300px] overflow-y-auto py-1 custom-scrollbar">
        @for (option of filteredOptions; track $index) {
          <!-- Item -->
          <li
            (click)="select(option)"
            (mouseenter)="activeIndex = $index"
            class="px-4 py-2.5 cursor-pointer text-sm transition-colors flex items-center justify-between"
            [ngClass]="{
              'bg-blue-600 text-white': $index === activeIndex,
              'text-gray-900 dark:text-gray-100': $index !== activeIndex,
              'hover:bg-gray-100 dark:hover:bg-gray-700': $index !== activeIndex,
            }"
          >
            <!-- Label -->
            <span>{{ getDisplayLabel(option) }}</span>
            <!-- Checkmark Icon -->
            @if (isSelected(option)) {
              <app-icon
                name="checkmark"
                stroke="none"
                fill="currentColor"
                class="w-4 h-4"
                [class.text-white]="$index === activeIndex"
                [class.text-blue-600]="$index !== activeIndex"
              />
            }
          </li>
        }
        <!-- Empty State -->
        @if (filteredOptions.length === 0) {
          <li class="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
            <p class="text-xs italic">No search results</p>
          </li>
        }
      </ul>
    </div>
  }
</div>
